<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div v-if="!showPageLoader" class="row">
            <div class="col-lg-12">
                <div class="row">
                    <template  v-for="(field, index) in fields">
                         <!-- Company Fetch Fields -->
                         <template v-if="route.includes('setup-profile') && showCompanyFeature && index == 0">
                            <company-auto-fill :fields="fields"></company-auto-fill>
                        </template>
                        <!-- Company Fetch Fields End -->
                        <div
                            v-if=""
                            :key="index"
                            :class="{
                                [field.class]: true,
                                'col-lg-12':
                                    field.type == 'heading' ||
                                    field.type == 'multi-text-field' ||
                                    field.type == 'multi-field' ||
                                    field.colSize == '12',
                                'col-md-4':
                                    (field.type !== 'heading' &&
                                        !field.class) ||
                                    field.colSize == '4',
                                'col-md-8':
                                    (index == 4 ||
                                        index == 6 ||
                                        field.colSize == '8') &&
                                    section == 'account-info',
                                'col-md-5':
                                    (field.key == 'identityInfo.number' ||
                                        field.key ==
                                            'identityInfo.passport.number') &&
                                    section == 'setup-profile',
                            }"
                        >
                            <div
                                v-if="field.type == 'heading' && index > 0"
                                class="form-border"
                            ></div>

                            <component
                                :is="field.type"
                                :field="field"
                                :data-segment-id="dataSegmentId"
                                :key="field.id"
                            ></component>
                        </div>
                        <!-- Address Fetch Fields -->
                        <!-- <template v-if="showAddressFeature && field.type == 'heading' && field.title=='Contact Information'">
                            <address-auto-fill :fields="fields"></address-auto-fill>
                        </template> -->
                        <!-- Address Fetch Fields End -->
                    </template>

                    <div class="col-lg-12">
                        <div class="form-border"></div>
                    </div>
                </div>
                <b-button
                    v-if="configData.documentUpload == true || !$route.path.includes('setup-profile')"
                    size="sm"
                    class="mr-3"
                    variant="secondary"
                    @click="$router.go(-1)"
                >
                    Back
                </b-button>
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    btn-label="CONTINUE"
                    class="mr-3"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                ></base-button>

                <span v-if="loading" class="secondary-color">
                    Please wait. We're processing your request...</span
                >
            </div>
        </div>
        <!-- When data is loading -->
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
        <confirmation-popup
                :customerId="customerId"
                :message = "message"
                :type = "type"
                @updateExistsCheck="updateExistsCheck"
        ></confirmation-popup>
        <KYBConfirmPopup
        :customerId="customerId"
        :message = "message"
        :type = "type"
        confirmText="Create a new profile"
        cancelText="Do not proceed"
        customBtnText="Tag to existing profile"
        :customBtnFunction="tagToExistingCustomers"
        @updateExistsCheck="updateExistsCheck"
        ></KYBConfirmPopup>
    </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import request from '@/utils/request'

import Heading from '@/components/registration/Heading.vue'
import TextField from '@/components/registration/TextField.vue'
import MultiTextField from '@/components/registration/MultiTextField.vue'
import MultiField from '@/components/registration/MultiField.vue'
import TextArea from '@/components/registration/TextArea.vue'
import DatePicker from '@/components/registration/DatePicker.vue'
import List from '@/components/registration/List.vue'
import Dropdown from '@/components/registration/Dropdown.vue'
import MultiSelect from '@/components/registration/MultiSelect.vue'
import MultiSelectOld from '@/components/registration/MultiSelectOld.vue'
import Radio from '@/components/registration/Radio.vue'
import Checkbox from '@/components/registration/Checkbox.vue'
import PhoneNumber from '@/components/registration/PhoneNumber.vue'
import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocumentExpiry from '@/components/registration/IdentityDocumentExpiry.vue'
import Country from '@/components/registration/Country.vue'
import Nationality from '@/components/registration/Nationality.vue'
import TaxId from '@/components/registration/TaxId.vue'
import WorkType from '@/components/registration/WorkType.vue'
import Industry from '@/components/registration/Industry.vue'
import TermsAndCondition from '@/components/registration/TermsAndCondition.vue'
import FileInput from '@/components/registration/FileInput.vue'
// import OtpModal from '@/components/registration/OtpModal.vue'
import OtherNationalities from '@/components/registration/OtherNationalities.vue'
import SourceoffundsEvidence from '@/components/registration/SourceOfFundsDocument.vue'
import SourceofwealthEvidence from '@/components/registration/SourceOfWealthDocument.vue'
import AddressAutoFill from '@/components/AddressAutoFill.vue'
import CompanyAutoFill from '@/components/CompanyAutoFill.vue'
import ConfirmationPopup from '@/components/popups/ConfirmationPopup.vue'
import KYBConfirmPopup from '@/components/popups/KYBConfirmPopup.vue'

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {
        CompanyAutoFill,
        AddressAutoFill,
        Heading,
        TextField,
        TextArea,
        DatePicker,
        List,
        Dropdown,
        Radio,
        Checkbox,
        PhoneNumber,
        IdentityType,
        IdentityDocumentExpiry,
        Country,
        Nationality,
        TaxId,
        WorkType,
        Industry,
        TermsAndCondition,
        // OtpModal,
        OtherNationalities,
        SourceoffundsEvidence,
        SourceofwealthEvidence,
        MultiField,
        MultiTextField,
        MultiSelect,
        MultiSelectOld,
        FileInput,
        ConfirmationPopup,
        KYBConfirmPopup,
    }, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            section: 'setup-profile',
            fields: [],
            showPageLoader: true,
            is_data_fetched: false,
            riskFactor: null,
            configData: [],
            customerId: null,
            message: null,
            type: null,
            existsCheck:false,
            showAddressFeature: process.env.VUE_APP_AUTO_ADDRESS_FILL == 'true',
            showCompanyFeature: process.env.VUE_APP_AUTO_FILL_COMPANY == 'true'
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapState({
            restrictDuplicateCustomers: (state) =>
                state.registration.restrictDuplicateCustomers,
        }),

        ...mapGetters(['loading']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        route(){
          return this.$route.path
        },
    }, // End of Component > mounted

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    created() {
        this.configData = this.$store.state.registration.configData
    },
    async mounted() {
        const path = this.$route.path.split('/')
        await this.getRecords()

        if (path[path.length - 1] == 'setup-profile') {
            if (this.configData.nameScreening == false) {
                if (this.configData.riskFactor == false || this.configData.accountinfo == false) {

                        this.$router.push({ name: 'self-registration-company-preview' })
                
                } else {
                    if (this.configData.accountinfo == false) {
                        this.$router.push({ name: 'self-registration-company-preview' })
                    }
                    else {
                        this.$router.push({
                        name: 'self-registration-company-account-info',
                    })
                    }
                
                }
            }
        }
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */

        checkField(field) {
            let excludeFields = ['occupationInfo.relationshipStartDate',
            'enhancedDueDiligence','accountInfo.enhancedDueDiligence.dateOfEdd',
            'accountInfo.enhancedDueDiligence.isScrutinyPerformed','accountInfo.enhancedDueDiligence.isCustBusInquired',
            'accountInfo.enhancedDueDiligence.isManagementApproval','accountInfo.enhancedDueDiligence.isFirstPayment',
            'accountInfo.enhancedDueDiligence.scrutinyRemarks','accountInfo.enhancedDueDiligence.custBusInquiredRemarks',
            'accountInfo.enhancedDueDiligence.managementApprovalRemarks','accountInfo.enhancedDueDiligence.firstPaymentRemarks',
            'documentInfo.scrutiny.fileName','documentInfo.custBusInquired.fileName','documentInfo.managementApproval.fileName',
            'documentInfo.firstPayment.fileName',
            'strInformation','accountInfo.isStr','accountInfo.strDate','accountInfo.strReason','faceToFaceDeclaration','accountInfo.isf2f']

            const fieldFound = excludeFields.find(
                (fieldObj) => fieldObj === field.key
            )
            if (fieldFound) {
                return false
            }
            if (field.status && field.status == 'active') {
                if (
                    field.visibleTo &&
                    field.visibleTo.indexOf('company') > -1
                ) {
                    return true
                }
            }
            return false
        },

        async onSubmit() {
            // validate the form fields
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                this.$store.commit('setLoading', true)
                if (!this.existsCheck && this.configData.restrictDuplicateCustomers && (this.$store.state.registration.form.identityInfo.number || this.$store.state.registration.form.identityInfo.passport.number)) {
                    //check customer nic if already exists with their datasegment
                    let error = false
                    try {
                        const params = {}
                        params.dataSegmentId = this.dataSegmentId
                        params.nationalId =
                            this.$store.state.registration.form.identityInfo.number
                        params.passport =
                            this.$store.state.registration.form.identityInfo.passport.number
                        const { data } = await request({
                            url: '/customers/exists',
                            method: 'get',
                            params,
                        })
                    } catch (e) {
                        error = e
                    }
                    if (error) {
                        // this.$store.commit('setError', error)
                        this.openPopup('confirmation-popup','',error,'existsCheck')
                        // this.existsCheck=true
                        this.$store.commit('setLoading', false)
                        return false
                    }
                }

                this.nextModule('on-submit')
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        /**
         * get the form fields when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        section: this.section,
                        isEdit:false,
                        type:"company",
                        uaepassfield:this.configData.uaepassfield
                    },
                })
                this.showPageLoader = false
                this.fields = data.data
            } catch (error) {
                console.log(error)
            }
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method

        async nextModule(type = '') {
            //uncomment if account-info depend on risk factor switch

            // if ( this.configData.riskFactor == false) {
            //     this.$router.push('/self-register-company/preview')
            // } else {
            //     this.$router.push('/self-register-company/account-info')
            // }

            if(this.configData.accountinfo == false)
            {
                this.$router.push({ name: 'self-registration-company-preview' })
            }
            else{
                this.$router.push({
                        name: 'self-registration-company-account-info',
                    })
            }

        },
        async openPopup(popup,customerId,message,type)
        {
            this.customerId=customerId
            this.message=message
            this.type=type
            this.$bvModal.show(popup)
        },
        async updateExistsCheck(value)
        {
            if(!value)
            {
                if(this.configData.documentUpload==true)
                {
                    this.$router.push('/self-company/upload-document')
                }
                else
                {
                    this.$store.commit('initDefaultFields', 'form')
                    // this.$router.go(0)
                }
            }
            else
            {
                this.existsCheck=value
            }
        },
        async tagToExistingCustomers()
        {
           console.log("need to run from account-info")
        },
    }, // End of Component > watch
} // End of export default
</script>
